import posthog from "posthog-js";

// PostHog Project API Key — client-side public, safe to commit
const POSTHOG_PROJECT_TOKEN = "phc_vxUc4Q5QBp5jxESPHiMsQPtEixKgLGMYkb4hreojJjp9";
const POSTHOG_HOST = "https://eu.i.posthog.com";

export const posthogEnabled = POSTHOG_PROJECT_TOKEN.startsWith("phc_") && !POSTHOG_PROJECT_TOKEN.includes("REPLACE");

export const posthogOptions = {
    api_host: POSTHOG_HOST,
    ui_host: "https://eu.posthog.com",
    defaults: "2026-05-30",
    capture_pageview: false,
    capture_pageleave: true,
    capture_exceptions: true,
    enable_recording_console_log: true,
    capture_performance: {
        network_timing: true,
    },
    session_recording: {
        maskAllInputs: true,
        maskTextSelector: ".ph-no-capture",
        // 录屏时间线中记录网络请求（XHR/Fetch），便于直观定位失败的接口调用。
        recordHeaders: true,
        recordBody: true,
        recordPerformance: true,
    },
    tracing_headers: ["backend.heicreative.co.uk", "localhost"],
};

if (posthogEnabled) {
    posthog.init(POSTHOG_PROJECT_TOKEN, posthogOptions);
}

export default posthog;
